import { Stack, Textarea } from '@mantine/core';
import { useUpdateContact, type Contact } from '@/models/contacts';
import { FormSaveBar } from '@/components/FormSaveBar';
import { CollapsibleCard } from '@/components/CollapsibleCard';
import { useCardForm } from '@/lib/useCardForm';

type Values = {
  notes: string;
};

export function NotesCard({ contact }: { contact: Contact }) {
  const update = useUpdateContact();
  const { form, dirty, saving, handleSubmit } = useCardForm<Values>({
    initialValues: { notes: contact.notes ?? '' },
    save: (dirtyValues) =>
      update.mutateAsync({ id: contact.id, ...dirtyValues }),
    successMessage: 'Notes saved',
  });

  return (
    <CollapsibleCard title="Notes">
      <form onSubmit={handleSubmit}>
        <Stack gap="xs">
          <Textarea
            label="Notes"
            size="xs"
            autosize
            minRows={2}
            {...form.getInputProps('notes')}
          />
          {dirty && <FormSaveBar saving={saving} onDiscard={form.reset} />}
        </Stack>
      </form>
    </CollapsibleCard>
  );
}
